import React from "react";
import Sidebar from "../Sidebar";
import ComplainList from "../Admin/ComplainList";

const ComplainDashboard = () => {
  return (
    <Sidebar>
      <ComplainList />
    </Sidebar>
  );
};

export default ComplainDashboard;
